<template>
    <div v-if="article.article_languages[0] != null" class="banner-one-slide-1">
        <figure class="trans right-trans">
            <img :src="article.mobile_blob != null ? article.mobile_blob.url : article.blob.url" alt="" title="" class="for-msite"/>
            <img v-if="article.blob" :src="article.blob.url" alt="" title="" class="for-desktop"/>
            <figcaption class="trans top-trans delay-1">
                <div class="banner-category"><a
                    :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{
                        article.category.category_languages[0].pivot.name
                    }}</a>
                </div>
                <h1><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h1>
                <p v-if="article.second_author == null"><span>{{ $t('by') }}</span>{{ article.author.author_languages[0].pivot.name }}</p>
                <p v-else><span>{{ $t('by') }}</span>{{ article.author.author_languages[0].pivot.name }} &  {{ article.second_author.author_languages[0].pivot.name }}</p>
            </figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    name: "Banner",
    props: {
        article: {
            type: Object,
            default: null
        },
    }
}
</script>

<style scoped>

</style>
